import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { TranslocoLocaleModule } from '@ngneat/transloco-locale';
import { ButtonModule, CommonWordingModule, LoadingIndicatorModule, TemplateVariablesModule } from '@platform-frontend/ui-tools';
import { MatomoTrackClickDirective } from 'ngx-matomo-client';
import { TranslocoMarkupModule } from 'ngx-transloco-markup';
import { SubscriptionCancelConfirmationTextComponent } from './subscription-cancel-confirmation-text/subscription-cancel-confirmation-text.component';
import { SubscriptionCancelComponent } from './subscription-cancel/subscription-cancel.component';

@NgModule({
  declarations: [SubscriptionCancelConfirmationTextComponent, SubscriptionCancelComponent],
  exports: [SubscriptionCancelConfirmationTextComponent, SubscriptionCancelComponent],
  imports: [
    ButtonModule,
    CommonModule,
    CommonWordingModule,
    LoadingIndicatorModule,
    MatomoTrackClickDirective,
    TemplateVariablesModule,
    TranslocoMarkupModule,
    TranslocoLocaleModule,
    TranslocoModule
  ]
})
export class MarketplaceAssetModule {}
